module.exports = __webpack_public_path__ + "img/pedro.412f271d.png";